import { render, staticRenderFns } from "./TeacherAdminPage.vue?vue&type=template&id=116f24ee&scoped=true&"
import script from "./TeacherAdminPage.vue?vue&type=script&lang=js&"
export * from "./TeacherAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f24ee",
  null
  
)

export default component.exports